export default {"src":"/_next/static/media/bg-image-tank.23d2556a.svg","height":311,"width":574,"blurWidth":0,"blurHeight":0};